var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgImageCard = function SvgImageCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 5c1.1 0 2 .9 2 2v10.02c0 1.1-.9 1.98-2 1.98H3c-1.1 0-2-.88-2-1.98V7c0-1.1.9-2 2-2zM4 7a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1zm9 7a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2zm0-3a1 1 0 1 0 0 2h3a1 1 0 1 0 0-2zm0-3a1 1 0 1 0 0 2h5a1 1 0 1 0 0-2z",
    clipRule: "evenodd"
  })));
};
export default SvgImageCard;